import { createVNode as o, mergeProps as s } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/PlusFilled.js";
import m from "../components/PfIcon.js";
const r = (e, l) => {
  const t = {
    ...e,
    ...l.attrs
  };
  return o(m, s(t, {
    icon: i
  }), null);
};
r.displayName = "PlusFilled";
r.inheritAttrs = !1;
export {
  r as default
};
